import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-proctoring-terminated',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './proctoring-terminated.component.html',
  styleUrl: './proctoring-terminated.component.css'
})
export class ProctoringTerminatedComponent {
  reason: string | null = null;

  get formattedReason(): string {
    if (!this.reason) return 'UNKNOWN';
    
    const map: Record<string, string> = {
      'MAX_WARNINGS_EXCEEDED': 'MAX WARNING EXCEEDED',
      'CRITICAL_VIOLATION': 'CRITICAL VIOLATION',
      'TAB_SWITCH_TIMEOUT': 'TAB SWITCH TIMEOUT',
      'CAMERA_TURNED_OFF': 'CAMERA TURNED OFF'
    };

    return map[this.reason] || this.reason.replace(/_/g, ' ').toUpperCase();
  }

  constructor(
    private dialogRef: MatDialogRef<ProctoringTerminatedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { reason: string | null }
  ) {
    if (data && data.reason) {
      this.reason = data.reason;
    }
  }

  onOkay(): void {
    this.dialogRef.close(true);
  }
}
